import DefaultValidation from '@/services/validations/DefaultValidation';
import { isNull } from "@/functions/Util";

export default class MotivoAtendimentoValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        let minfotos = parseInt(model.qtdMinimaFoto);

        if (refs.idErpInput.required && isNull(model.idMotivoAtendimentoErp)) {
			refs.idErpInput.focusedOut = true;
			validated = false;
		}

        if (isNull(model.descricao)) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }

        if (isNaN(minfotos) || minfotos < 0) {
            refs.minFotosInput.focusedOut = true;
            validated = false;
        }

        return validated;
    }

}